module.exports = __webpack_public_path__ + "static/img/1.57fbad5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/21/zh/1.png
// module id = 0ub7
// module chunks = 0